import { createEvent } from '@cobuildlab/react-simple-state';
import {
  NavigationMapEntry,
  TrackingAction,
  WEB_NAVIGATION_MAP,
} from '@rapid-recovery-agency-inc/insightt-shared';
import { createAnalyticEvent } from '../../shared/analytics/services';

export const OnClientsListForPie = createEvent({ initialValue: new Map() });
export const OnClientsListForTable = createEvent({ initialValue: new Map() });
export const OnClientsListError = createEvent();

export const OnTargetRecoveryRatesList = createEvent({
  initialValue: [],
});
export const OnTargetRecoveryRatesError = createEvent();

export const trackClickOnTotalRepoModal = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_TOTAL_REPOSSESSIONS.views.DAILY_REPORT.subViews
    .TOTAL_REPOSSESSIONS_QUICK_VIEW,
  (tab: string) => ({ $tab: tab }),
);

export const trackOnTotalCheckInsTabClick = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_TOTAL_CHECK_INS.views.DAILY_REPORT.subViews
    .TOTAL_CHECK_INS_QUICK_VIEW,
  ({ role, tab }: { role: null | string; tab: string }) => ({
    $role: role,
    $tab: tab,
  }),
);

export const trackClickOnAccountsNotChecked = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_ACCOUNTS_NOT_CHECKED.views.DAILY_REPORT.subViews
    .ACCOUNTS_NOT_CHECKED_QUICK_VIEW,
  ({ role, tab }: { role: null | string; tab: string }) => ({
    $role: role,
    $tab: tab,
  }),
);

export const trackOpenOnRepoHitListModal = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_REPOSSESSION_HIT_LIST.views.DAILY_REPORT.subViews
    .REPOSSESSION_HIT_LIST_QUICK_VIEW,
  (role: null | string) => ({ $role: role }),
);

export const trackClickOnTotalSpots = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_TOTAL_SPOTTED.views.DAILY_REPORT.subViews
    .TOTAL_SPOTTED_QUICK_VIEW,
  ({ role, tab }: { role: null | string; tab: string }) => ({
    $role: role,
    $tab: tab,
  }),
);

export const trackClickOnOpenTargetRecoveryRate = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_DAILY_RECOVERY_RATE.views.DAILY_REPORT.subViews
    .DAILY_RECOVERY_RATE_QUICK_VIEW,
  ({ role }: { role: null | string }) => ({
    $role: role,
  }),
);

export const trackOnSpottedNotSecuredTabClick = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_SPOTTED_NOT_SECURED.views.DAILY_REPORT.subViews
    .SPOTTED_NOT_SECURED_QUICK_VIEW,
  ({ role, tab }: { role: null | string; tab: string }) => ({
    $role: role,
    $tab: tab,
  }),
);

export const trackOnHitsTabClick = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.REPORTS.features.METRIC_CARD_SPOTTED_NOT_SECURED.views.DAILY_REPORT.subViews
    .SPOTTED_NOT_SECURED_QUICK_VIEW,
  ({
    role,
    userTab,
    hitType,
    hitStatus,
  }: {
    role: null | string;
    userTab: string;
    hitType: string;
    hitStatus?: string;
  }) => ({
    $role: role,
    $userTab: userTab,
    $hitType: hitType,
    $hitStatus: hitStatus,
  }),
);

interface DateRangePickerTrackingPayload {
  year: number | null;
  role: string | null;
  tenant: string | null;
}

export const trackDateRangePickerChange = (
  entry: NavigationMapEntry,
  { year, role, tenant }: DateRangePickerTrackingPayload,
) => {
  createAnalyticEvent(
    TrackingAction.DATE_RANGE_CHANGE,
    entry,
  )({
    $year: year,
    $role: role,
    $tenant: tenant,
  });
};

export const trackReportsViewed = (
  event: TrackingAction,
  entry: NavigationMapEntry,
  {
    branchName,
    chartSelected,
    chartType,
    daily,
    dailyMap,
  }: {
    timeFrame?: string;
    branchName?: string;
    chartSelected?: string;
    chartType?: string;
    daily?: string;
    dailyMap?: string;
  },
) => {
  createAnalyticEvent(
    event,
    entry,
  )({
    $branch_name: branchName,
    $chart_selected: chartSelected,
    $chart_type: chartType,
    $daily: daily,
    $daily_map: dailyMap,
  });
};
